export const isCreateDealValid = ({ createDeal, tier, priority, amazonasin }) => createDeal === 'true' &&
 tier && priority && amazonasin.length > 0;

export const clearCRMFilterValues = (filterData) => {
  const { createDeal, priority, tier, assignee, ...rest } = filterData;

  return { ...rest, createDeal: undefined, priority: undefined, tier: undefined, assignee: undefined };
};